import { Controller } from 'react-hook-form';
import MediaCarouselEditor from './Carousel/Media-Carousel-Editor';
import ProductCarouselEditor from './Carousel/Product-Carousel-Editor';
import { RadioButton } from 'primereact/radiobutton';
import styles from '../stylesheets/marketingCarousel.module.css';

const MarketingCarouselTemplate = ({
  control,
  setValue,
  textAreaRef,
  getFormErrorMessage,
  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,
  messsageVariables,
  menuRef,
  showEmoji,
  setShowEmoji,
  handleEmojiClick,
  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,
  watch,
}) => {
  const carouselType = watch('carouselType');

  return (
    <div className="w-full">
      <div className="mt-4 w-full">
        <label className="mb-4">Carousel Type</label>

        <Controller
          name="carouselType"
          control={control}
          defaultValue="MEDIA"
          render={({ field }) => {
            const handleCarouselChange = (value) => {
              field.onChange(value);

              if (value === 'MEDIA') {
                setValue('productCards', []);
                setValue('productCTAType', 'VIEW');
                setValue('productCTA', {});
              }

              if (value === 'PRODUCT') {
                setValue('carouselCards', []);
              }
            };

            return (
              <div className={styles.carouselTabs}>
                <div
                  className={`${styles.carouselTab} ${
                    field.value === 'MEDIA' ? styles.carouselTabActive : ''
                  }`}
                  onClick={() => handleCarouselChange('MEDIA')}
                >
                  Media Carousel
                </div>

                <div
                  className={`${styles.carouselTab} ${
                    field.value === 'PRODUCT' ? styles.carouselTabActive : ''
                  }`}
                  onClick={() => handleCarouselChange('PRODUCT')}
                >
                  Product Carousel
                </div>
              </div>
            );
          }}
        />
      </div>

      {carouselType === 'MEDIA' && (
        <MediaCarouselEditor
          control={control}
          setValue={setValue}
          textAreaRef={textAreaRef}
          getFormErrorMessage={getFormErrorMessage}
          SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
          showSpamSuggestions={showSpamSuggestions}
          setShowSpamSuggestions={setShowSpamSuggestions}
          checkForSpam={checkForSpam}
          messsageVariables={messsageVariables}
          menuRef={menuRef}
          showEmoji={showEmoji}
          setShowEmoji={setShowEmoji}
          handleEmojiClick={handleEmojiClick}
          tempVariables={tempVariables}
          handleEditVariable={handleEditVariable}
          handleDeleteVariable={handleDeleteVariable}
          watchContent={watchContent}
          watch={watch}
        />
      )}

      {carouselType === 'PRODUCT' && (
        <ProductCarouselEditor
          control={control}
          setValue={setValue}
          textAreaRef={textAreaRef}
          getFormErrorMessage={getFormErrorMessage}
          SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
          showSpamSuggestions={showSpamSuggestions}
          setShowSpamSuggestions={setShowSpamSuggestions}
          checkForSpam={checkForSpam}
          messsageVariables={messsageVariables}
          menuRef={menuRef}
          showEmoji={showEmoji}
          setShowEmoji={setShowEmoji}
          handleEmojiClick={handleEmojiClick}
          tempVariables={tempVariables}
          handleEditVariable={handleEditVariable}
          handleDeleteVariable={handleDeleteVariable}
          watchContent={watchContent}
          watch={watch}
        />
      )}
    </div>
  );
};

export default MarketingCarouselTemplate;
